'use client';

import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { GET_HEADER_BOOKING_FLOW_INFORMATION, GET_HEADER_BOOKING_INFORMATION } from '@whitbread-eos/api';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { enhanceCheckoutStepList } from '../selectors';
import { analytics } from '../services';
import { isStringValid } from '../validators';
import useCustomLocale from './use-custom-locale';
import { graphQLRequest } from './use-request';
var BLACKLIST_ROUTES = ['/repeat-booking'];
export default function useHotelBrands(_ref) {
  var basketReference = _ref.basketReference,
    channel = _ref.channel,
    queryClient = _ref.queryClient;
  var _useCustomLocale = useCustomLocale(),
    country = _useCustomLocale.country,
    language = _useCustomLocale.language;
  var _ref2 = useRouter() || {
      query: {},
      route: ''
    },
    route = _ref2.route;
  var activePage = route === null || route === void 0 ? void 0 : route.split('/')[channel === 'BB' ? 3 : 1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    brand = _useState2[0],
    setBrand = _useState2[1];
  var _useState3 = useState({
      activeStep: 0,
      steps: []
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    stepProgress = _useState4[0],
    setStepProgress = _useState4[1];
  var isBlacklistedRoute = BLACKLIST_ROUTES.some(blacklistedElem => blacklistedElem === route);
  useEffect(() => {
    if (isStringValid(basketReference) && !isBlacklistedRoute) {
      getBookingFlowInformation(basketReference, channel);
    }
  }, [basketReference]);
  useEffect(() => {
    var _stepProgress$steps;
    if ((stepProgress === null || stepProgress === void 0 || (_stepProgress$steps = stepProgress.steps) === null || _stepProgress$steps === void 0 ? void 0 : _stepProgress$steps.length) > 0) {
      analytics.update({
        bookingStepsTotal: stepProgress.steps.length,
        bookingCurrentStep: stepProgress.activeStep
      });
    }
  }, [stepProgress]);
  var getBookingFlowInformation = useCallback(function () {
    var _ref3 = _asyncToGenerator(function* (basketReference, channel) {
      var biQueryInput = {
        basketReference: basketReference,
        country,
        language,
        bookingChannelCriteria: {
          channel: channel,
          subchannel: 'WEB',
          language: language === 'en' ? 'EN' : 'DE'
        }
      };
      var bookingInformationQuery = queryClient.fetchQuery({
        queryKey: ['GetBookingInformation', biQueryInput.language, biQueryInput.country, biQueryInput.basketReference],
        queryFn: () => graphQLRequest(GET_HEADER_BOOKING_INFORMATION, biQueryInput)
      });
      yield bookingInformationQuery.then(function () {
        var _ref4 = _asyncToGenerator(function* (result) {
          var bookingInfo = result === null || result === void 0 ? void 0 : result.bookingInformation;
          var _ref5 = bookingInfo !== null && bookingInfo !== void 0 ? bookingInfo : {},
            _ref5$bookingFlowId = _ref5.bookingFlowId,
            bookingFlowId = _ref5$bookingFlowId === void 0 ? '' : _ref5$bookingFlowId,
            _ref5$hotelId = _ref5.hotelId,
            hotelId = _ref5$hotelId === void 0 ? '' : _ref5$hotelId;
          var bookingFlowInformationRequest = queryClient.fetchQuery({
            queryKey: ['GetBookingFlowInformation', bookingFlowId, hotelId, language, country],
            queryFn: () => graphQLRequest(GET_HEADER_BOOKING_FLOW_INFORMATION, {
              bookingFlowId,
              hotelId,
              language,
              country
            })
          });
          yield bookingFlowInformationRequest.then(bfiDataResp => {
            var _ref6 = (bfiDataResp === null || bfiDataResp === void 0 ? void 0 : bfiDataResp.bookingFlowInformation) || {
                bookingFlowSteps: [{}]
              },
              bookingFlowSteps = _ref6.bookingFlowSteps,
              brand = _ref6.brand;
            setBrand(brand);
            setStepProgress(enhanceCheckoutStepList(bookingFlowSteps, activePage));
          });
        });
        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }());
    });
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  return {
    brand,
    stepProgress
  };
}